import React from 'react';
import PropTypes from 'prop-types';
import { Col } from '../../util_grid/grid.js';
import Link from "@components/base_link/component.jsx";
import { Button, TitleAndSubtitle, Metabar, Icon } from 'audamatic-ui';
import Text from '@text';
import { t } from '@utils/i18n';
import { checkOpeningAndClosingHoursShop, openMaps } from '@utils';

import './styles.scss';

import ingService from './assets/ingService.png';
import geldmaatService from './assets/geldmaatService.png';
import postNlService from './assets/postNLService.png';
import tobaccoSale from './assets/tobaccoSale.svg';
import deService from './assets/deService.svg';

const AnkeilerStores = (props) => {
  const {
    xs,
    sm,
    md,
    city,
    storeId,
    address,
    attributes,
    phoneBusiness,
  } = props

  const iconMap = {
    ingService,
    geldmaatService,
    postNlService,
    tobaccoSale,
    deService,
  }

  const { latitude, longitude } = attributes;
  const urlEncodedCity = encodeURIComponent(city).toLowerCase();
  const allServicesString = t('storesOverview.filter.allFilters')
  const allServices = allServicesString.split(', ');
  const hasAnyService = allServices.some(service => !!props[service]);

  const title =
    <Link to={`/winkels/${urlEncodedCity}/${storeId}`} title={storeId}>
      <span dangerouslySetInnerHTML={{ __html: city }}></span>
    </Link>

  const subtitle =
    <Link to={`/winkels/${urlEncodedCity}/${storeId}`} title={storeId}>
      <span dangerouslySetInnerHTML={{ __html: address }}></span>
    </Link>

  const {
    isOpen
  } = checkOpeningAndClosingHoursShop(attributes);

  const renderIconComponent = (service, index) => {
    const icon = iconMap[service];

    // For .png files
    const isString = typeof icon === 'string';
    if (isString) {
      return <img key={index} src={icon} height="20" />;
    }

    const Component = icon;
    return <Component key={index} width={20} height={20} />;
  }


  return (
    <Col xs={xs || 6} sm={sm || 4} md={md || 3}
      className="ankeiler ankeiler-stores expandable"
    >
      {/*
        PLACE IMAGE OF STORE HERE 
        <div className="image wrapper">
          <div className="product-image-wrapper"></div>
        </div> 
        */}
      <div className="equal-cols">
        <div className="layout-top haslink">
          <TitleAndSubtitle
            title={title}
            subtitle={subtitle}
            data-test-id="titleAndSubtitle"
          />
        </div>
        <div className="ankeiler-container">
          <div className="layout-middle">
            <Metabar>
              <span className={`${isOpen ? 'open' : 'closed'}`}>
                <Text>{`${isOpen ? 'storesOverview.ankeiler.open' : 'storesOverview.ankeiler.closed'}`}</Text>
              </span>
              <span className="phone">
                <Icon name="Phone" size="xs" /> {phoneBusiness}
              </span>
              <span className="route" onClick={openMaps(latitude, longitude)}>
                <Icon name="MapPin" size="xs" />
                <Text>storesOverview.ankeiler.route</Text>
              </span>
            </Metabar>
          </div>
          <div className="layout-bottom">
            <div className="block-extend">
              <div className="meta-info">
                <span className="services">
                  {hasAnyService && <Text>storesOverview.ankeiler.services</Text>}
                  <div className="logos">
                    {allServices.map((service, index) => {
                      /* 
                      ** Check if the service exists as a prop
                      ** If not, the service is not available for this store so dont render the icon
                      */
                      if (props[service]) {
                        return (
                          renderIconComponent(service, index)
                        )
                      }
                    })}
                  </div>
                </span>
              </div>
              <span>
                <div className="row-centered decorated">
                  <div className="to-basket">
                    <div className="giftcard-button">
                      <Link className="no-underline" to={`/winkels/${urlEncodedCity}/${storeId}`}>
                        <Button variant="primary" size="large" fullWidth={true}>
                          <Text>storesOverview.ankeiler.button</Text>
                        </Button>
                      </Link>
                    </div>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </Col>
  )
}

AnkeilerStores.propTypes = {
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  city: PropTypes.string,
  storeId: PropTypes.string,
  address: PropTypes.string,
  attributes: PropTypes.object,
}

export default AnkeilerStores;